// extracted by mini-css-extract-plugin
export default {"root":"ntvO2sz0O0"};